import {Injectable} from '@angular/core';
import {Alert, AlertController} from 'ionic-angular';

/*
  Generated class for the AlertProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AlertProvider {
    currentAlert: Alert

    constructor(
        private alertCtrl: AlertController
    ) {
        console.log('Hello AlertProvider Provider');
    }

    show(title: string, message: string, buttons: any = [], inputs: any = [], cssClass = '') {
        if (!buttons.length) {
            buttons.push('Ok')
        }
        let alertOptions: any = {
            title: title,
            subTitle: message,
            buttons: buttons,
            cssClass: buttons.length === 2 ? 'confirmAlert' : cssClass
        }
        if (inputs.length) {
            alertOptions.inputs = inputs
        }
        if (!this.currentAlert) {
            this.currentAlert = this.alertCtrl.create(alertOptions)
            this.currentAlert.present()
            this.currentAlert.onDidDismiss(() => {
                this.currentAlert = null
            })
        }
        return this.currentAlert
    }

}



// WEBPACK FOOTER //
// ./src/providers/alert/alert.ts